export const isStaging = window.runtimeConfig?.APP_ENV === "staging";
export const isProduction = window.runtimeConfig?.APP_ENV === "production";
